import { render, staticRenderFns } from "./parameters.vue?vue&type=template&id=2fdde52e&scoped=true&"
import script from "./parameters.vue?vue&type=script&lang=ts&"
export * from "./parameters.vue?vue&type=script&lang=ts&"
import style0 from "./parameters.vue?vue&type=style&index=0&id=2fdde52e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdde52e",
  null
  
)

export default component.exports